import depsloader from "../depsloader";
import 'sal.js/dist/sal.css';

export default function() {
  depsloader.load( "sal-animation" ).then( ( salAnimation ) => {
    salAnimation();
  } );
}
